import React from "react";
import "../style.scss";

const LoaderFull = ({ activeMessage }) => {
  return (
    <>
      {activeMessage ? (
        <>
          <div className="loader-overlay">
            <div className=" w-full mx-auto my-auto flex flex-col items-center gap-y-8  z-[99999]">
              <h2 className="text-center text-4xl font-bold">
                Não feche ou atualize o app!
                <br /> estamos enviando as consultas feitas no offline
              </h2>
              <div className="spinner "></div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="loader-overlay">
            <div className="spinner"></div>
          </div>
        </>
      )}
    </>
  );
};

export default LoaderFull;
